var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueryLibrary(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.75L9 20.25H10.5L15 3.75H13.5ZM5.95275 4.8045L0.89025 11.5545L0.5625 12L0.891 12.4455L5.9535 19.1955L7.17225 18.3045L2.4375 12L7.17225 5.6955L5.95275 4.8045ZM18.0465 4.8045L16.8278 5.6955L21.5625 12L16.8278 18.3045L18.0465 19.1955L23.109 12.4455L23.4375 12L23.109 11.5545L18.0465 4.8045Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryLibrary);
export default __webpack_public_path__ + "static/media/query-library.885ad8a3.svg";
export { ForwardRef as ReactComponent };